import Icon from '../components/Icon.vue'

Icon.register({
  'address-book': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M436 160h-20v64h20c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-20v64h20c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-20v48c0 26.5-21.5 48-48 48h-320c-26.5 0-48-21.5-48-48v-416c0-26.5 21.5-48 48-48h320c26.5 0 48 21.5 48 48v48h20c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zM208 128c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zM320 364.8v-19.2c0-31.8-30.1-57.6-67.2-57.6h-5c-12.2 5.1-25.7 8-39.8 8s-27.5-2.9-39.8-8h-5c-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2h179.2c12.4 0 22.4-8.6 22.4-19.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/address-book.js
// module id = 590
// module chunks = 0